import React, { useState } from 'react';
import classNames from 'classnames';
import CIcon from '@coreui/icons-react';
import { ISorter, Order } from '@transferz/models';

interface IDataTableHeaderProps {
  fields: any;
  sorterValues?: ISorter[];
  onSorterChange?: (values: ISorter[]) => void;
}

export const DataTableHeader: React.FunctionComponent<IDataTableHeaderProps> = ({
  fields, sorterValues: defaultSorterValues, onSorterChange,
}) => {
  const [sorterValues, setSorterValues] = useState(defaultSorterValues) as any;

  const handleSorting = (column: string, index: number): void => {
    let nextSorterValues = [...sorterValues];
    const sortedItemIndex = findSortedItem(index);
    if (sortedItemIndex !== -1) {
      nextSorterValues[sortedItemIndex] = {
        ...nextSorterValues[sortedItemIndex],
        order: nextSorterValues[sortedItemIndex]?.order === Order.ASC ? Order.DESC : Order.ASC,
      };
    } else {
      nextSorterValues = [...nextSorterValues, { by: column, order: Order.ASC }];
    }

    setSorterValues(nextSorterValues);
    onSorterChange && onSorterChange(nextSorterValues);
  };

  const findSortedItem = (index: number): number => (
    sorterValues.findIndex((sorterValue: ISorter) => sorterValue.by === fields?.[index]?.key)
  );

  return (
    <tr>
      {fields.map(({ label, sorter = false, key }: any, index: number) => {
        const sortedItemIndex = findSortedItem(index);
        return (
          <th
            onClick={() => {
              sorter && handleSorting(key, index);
            }}
            className={classNames([fields?.[index]?._classes, sorter && 'position-relative pr-4'])}
            style={{
              verticalAlign: 'middle',
              overflow: 'hidden',
              cursor: fields?.[index]?.sorter ? 'pointer' : 'default',
              ...fields?.[index]?._style
            }}
            key={index}
          >
            <div className="d-inline">{label}</div>
            {sorter && (
              <CIcon
                customClasses={classNames({
                  'position-absolute': true,
                  'icon-transition': true,
                  'arrow-position': true,
                  'transparent': !sorterValues?.[sortedItemIndex]?.order,
                  'rotate-icon': sorterValues?.[sortedItemIndex]?.order === Order.DESC,
                })}
                width={18}
                name="cilArrowTop"
              />
            )}
          </th>
        );
      })}
    </tr>
  );
}
